import { documentsAreaMessages } from '../../../messages';
import { Column } from '../../column';
import { ContractDocument } from '../contract';

export const contractColumns: Column<ContractDocument>[] = [
  {
    headerLabel: documentsAreaMessages.titleLabelTable,
    key: 'title',
    type: 'react-node',
  },
  {
    headerLabel: documentsAreaMessages.loadingDateLabelTable,
    key: 'uploadDate',
    type: 'date',
  },
  {
    headerLabel: documentsAreaMessages.signatureDateLabelTable,
    key: 'signDate',
    type: 'date',
  },
  {
    headerLabel: null,
    key: 'flagIsRead',
    type: 'react-node',
  },
];
